<template>
    <div>
        <!-- Toggle Button -->
        <button
            class="btn btn-link p-2 position-fixed"
            :class="isOpen ? 'd-none' : 'd-block'"
            style="top: 1rem; right: 1rem; z-index: 1050;"
            @click="toggleSidebar"
        >
            <font-awesome-icon icon="bars" style="color: var(--primary);"/>
        </button>

        <!-- Sidebar Navigation -->
        <div
            ref="sidebar"
            class="hg-sidebar-bg sidebar position-fixed h-100"
            :class="{ open: isOpen, scrolling: isScrolling }"
            @scroll="onScroll"
        >
            <!-- Close Button -->
            <button class="close-btn" @click="toggleSidebar">
                <font-awesome-icon icon="times" style="color: white;"/>
            </button>

            <nav>
                <ul class="list-unstyled p-3 mt-5">
                    <li v-for="slide in slides" :key="slide.id" class="slide-item">
                        <div
                            class="parent-header d-flex align-items-center"
                            @click="slide.children?.length ? toggleExpand(slide) : navigate(slide.path)"
                            :class="{ 'active-item': isActive(slide) }"
                        >
                            <font-awesome-icon
                                v-if="slide.children && slide.children.length"
                                icon="chevron-right"
                                class="toggle-icon fa-xs"
                                :class="{ expanded: expandedItems[slide.id] }"
                            />
                            <span class="parent-title ml-2">{{ slide.title }}</span>
                        </div>

                        <ul
                            v-if="slide.children && slide.children.length"
                            class="list-unstyled pl-3 child-list"
                            v-show="expandedItems[slide.id]"
                        >
                            <li
                                v-for="child in slide.children"
                                :key="child.id"
                                class="child-item"
                            >

                                <router-link
                                    :to="child.path"
                                    class="d-block"
                                    @click.native="navigateClose"
                                    :class="{ 'active-item': $route.path === child.path }"
                                >
                                    {{ child.title }}
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'SidebarNav',
    data() {
        return {
            isOpen: false,
            isScrolling: false,
            _scrollTimeout: null,
            expandedItems: {},
        }
    },
    computed: {
        ...mapGetters(['allSlides']),
        slides() {
            return this.allSlides
        },
    },
    watch: {
        '$route.path': {
            handler() {
                this.autoExpand()
            },
            immediate: true,
        },
    },
    methods: {
        toggleSidebar() {
            this.isOpen = !this.isOpen
        },
        navigate(path) {
            this.$router.push(path)
        },
        navigateClose() {
            this.toggleSidebar()
        },
        onScroll() {
            this.isScrolling = true
            clearTimeout(this._scrollTimeout)
            this._scrollTimeout = setTimeout(() => {
                this.isScrolling = false
            }, 500)
        },
        toggleExpand(slide) {
            this.$set(this.expandedItems, slide.id, !this.expandedItems[slide.id])
            if(this.$route.path != slide.path) {
                this.navigate(slide.path);
            }
        },
        isActive(slide) {
            if (this.$route.path === slide.path) return true
            if (slide.children) {
                return slide.children.some(child => child.path === this.$route.path)
            }
            return false
        },
        autoExpand() {
            this.slides.forEach(slide => {
                const shouldExpand =
                    slide.children && slide.children.some(child => child.path === this.$route.path)
                this.$set(this.expandedItems, slide.id, shouldExpand)
            })
        },
    },
}
</script>

<style scoped>
.sidebar {
    top: 0;
    right: 0;
    width: 250px;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1040;
    overflow-y: auto;

    /* Firefox: hide by default */
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
}

.sidebar.open {
    transform: translateX(0);
}

/* Close Button */
.close-btn {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: none;
    border: none;
    color: #476125;
    font-size: 1.25rem;
    cursor: pointer;
    z-index: 1050;
}

/* Parent header (clickable area) */
.parent-header {
    cursor: pointer;
    padding: 0.25rem 0;
    display: flex;
    padding-left: 5px;
    box-sizing: border-box;
}

.parent-title {
    color: white;
    font-family: Montserrat, sans-serif;
    font-weight: 400;
    font-size: 0.9em;
    padding: 8px;
}

.slide-item {
    transition: all 0.5s ease-out;
}

.slide-item:hover {
    transform: translateX(5px);
}

/* Active state */
/*
background: linear-gradient(90deg, rgba(71, 97, 37, 0.15) 0%, rgba(71, 97, 37, 0) 100%);
 */
.active-item {
    background: #000013;
    transition: all 0.3s ease-out;
}



/* Chevron icon */
.toggle-icon {
    color: white;
    transition: transform 0.2s ease;
}

.toggle-icon.expanded {
    transform: rotate(90deg);
}

/* Child list */
.child-list {
    margin-top: 0.25rem;
}

.child-item a,
.child-item router-link {
    display: block;
    color: white;
    text-decoration: none;
    padding: 10px 15px;
    font-size: 0.7em;
}

.child-item a.active-item,
.child-item router-link.active-item {
    background: linear-gradient(90deg, rgba(0, 0, 37, 0.15) 0%, rgba(0, 0, 37, 0.0) 100%);
}

.child-item a:hover,
.child-item router-link:hover {
    text-decoration: underline;
}
/*
//backdrop-filter: blur(10px);
//background-color: rgba(0,0,0,0.3);
*/
.hg-sidebar-bg {
    background: url('@/assets/cssImg/navbar-bg.jpg')  50%/cover no-repeat;
    box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.3);
}

/* —— WebKit scrollbar —— */
.sidebar::-webkit-scrollbar {
    width: 4px;
}

.sidebar::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
    background-color: rgba(71, 97, 37, 0.5);
    border-radius: 2px;
    opacity: 0;
    transition: opacity 0.2s, background-color 0.2s;
}

.sidebar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(71, 97, 37, 0.7);
}

/* —— Show when scrolling —— */
.sidebar.scrolling::-webkit-scrollbar-thumb {
    opacity: 1;
}

/* —— Firefox when scrolling —— */
.sidebar.scrolling {
    scrollbar-width: thin;
    scrollbar-color: rgba(71, 97, 37, 0.5) transparent;
}
</style>
